import { combineReducers } from 'redux';

import { reducers } from '../models';
import view from './view/reducer';

export default combineReducers({
    models: reducers,
    view
});
